const mutations = {
  
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js